import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import styled from "styled-components";
import AddParkForm from "../../components/ManageParks/AddParkForm";
import { ToastMessage } from "../../components/ToastMessage";
import Toggle from "../../components/Toggle";
import { uploadEventImage } from "../../services/eventsService";
import {
  Colors,
  DYNAMIC_PROMO_TYPES,
  NEW_PARK_VISIT_TIME_INIT,
} from "../../config/Constants";
import { validateDynamicPromotionData, validatePark } from "./validatePark";
import {
  addOutlet,
  fetchOutletFromId,
  updateOutlet,
} from "../../services/outletsService";
import ErrorSuccessModal from "../../components/Modal/ErrorSuccessModal";
import {
  getAddParkData,
  getFomattedParkData,
  getFormattedProductList,
  getFormattedProductListForDropdown,
  getParkTimingDetails,
} from "../../helper";
import { useLoadContext } from "../../contexts/LoadContext";
import ConfirmModal from "../../components/Modal/ConfirmModal";
import InfoAndText from "../../components/ManageParks/InfoAndText";
import ParksHeader from "../../components/ManageParks/ParksHeader";
import {
  fetchAllActiveProducts,
  fetchAllProducts,
} from "../../services/productService";
import dayjs from "dayjs";

interface StatusProps {
  status: boolean;
}

const AddPark = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState(true);
  const [isFailureModal, setIsFailureModal] = useState(false);
  const [isSuccessModal, setIsSuccessModal] = useState(false);
  const [isCancelModal, setIsCancelModal] = useState(false);
  const [rawOutletData, setRawOutletData] = useState({});
  const [dynamicPromoError, setDynamicPromoError] = useState({});
  const [dynamicPromoType, setDynamicPromoType] = useState("");
  const [dynamicPromoData, setDynamicPromoData] = useState({
    isEnabled: "true",
    products: [],
    details: [
      {
        minQty: 0,
        freeQty: 0,
      },
    ],
    restrictedDate: [],
    startDate: "",
    endDate: "",
    discountPercentage: "",
    promoCode: "",
    discountedPrice: "",
    isAllIncluded: false,
  });
  const [restrictProductDiscount, setRestrictProductDiscount] = useState([
    { product: "", excludeDate: [] },
  ]);
  const [productsOptions, setRestrictedProductOptions] = useState([]);
  const [errorMessage, setErrorMessage] = useState({
    heading: "",
    subHeading: "",
  });
  const [parkData, setParkData] = useState({
    name: "",
    type: "select",
    email: "",
    countryCode: "",
    phoneNumber: "",
    info: "",
    whatsappNumber: "",
    instaLink: "",
    fbLink: "",
    lat: "",
    long: "",
    address: "",
    iframe_url: "",
    tripAdvisor: "",
    logoUrl: new Array<string>(),
    imageUrl: new Array<string>(),
    masterName: "",
    masterEmail: "",
    bankName: "",
    accountNumber: "",
    legalEntity: "",
    sapCode: "",
    shortName: "",
    disclaimer: "",
    tc: "",
    segrateTimeSlot: "",
    mapImage: new Array<string>(),
    specialProductsDates: new Array<string>(),
    holidayAllowedDates: new Array<string>(),
    restrictedDates: new Array<string>(),
  });
  const [error, setError] = useState({
    name: "",
    type: "",
    email: "",
    countryCode: "",
    phoneNumber: "",
    info: "",
    whatsappNumber: "",
    instaLink: "",
    fbLink: "",
    lat: "",
    long: "",
    address: "",
    iframe_url: "",
    tripAdvisor: "",
    logoUrl: "",
    imageUrl: "",
    masterName: "",
    masterEmail: "",
    bankName: "",
    accountNumber: "",
    legalEntity: "",
    sapCode: "",
    time: {},
    disclaimer: "",
    timeSingle: "",
    timeType: "",
    tc: "",
    segrateTimeSlot: "",
    mapImage: "",
  });
  const [uploadedImage, setUploadedImage] = useState();
  const [time, setTime] = useState({
    type: "",
    timeMulti: { ...NEW_PARK_VISIT_TIME_INIT },
    timeSingle: { start: "", end: "" },
  });
  const { setLoader } = useLoadContext();

  const uploadEvent = (event: any) => {
    let img = new Image();
    img.src = window.URL.createObjectURL(event.target.files[0]);
    img.onload = async () => {
      if (
        event.target.name === "logoUrl" &&
        event.target.files[0].size > 2048756
        // ||
        // img.width > 512 ||
        // img.height > 512
      ) {
        toast.error(
          <ToastMessage message="Only JPEG or PNG files are allowed. Max size: 2MB." />,
          {
            hideProgressBar: true,
          }
        );
      } else if (
        event.target.name === "imageUrl" &&
        event.target.files[0].size > 2048756
        // ||
        // img.width > 672 ||
        // img.height > 378
      ) {
        toast.error(
          <ToastMessage message="Only JPEG or PNG files are allowed. Max size: 2MB." />,
          {
            hideProgressBar: true,
          }
        );
      } else if (
        event.target.name === "mapImage" &&
        event.target.files[0].size > 2048756
      ) {
        toast.error(
          <ToastMessage message="Only JPEG or PNG files are allowed. Max size: 2MB." />,
          {
            hideProgressBar: true,
          }
        );
      } else {
        try {
          let { data } = await uploadEventImage(event.target.files[0]);
          setUploadedImage(data.files[0]);
          let formData = { ...parkData };
          let formError = { ...error };
          if (event.target.name === "logoUrl") {
            //@ts-ignore
            formData["logoUrl"].push(data.files[0]);
            //@ts-ignore
            formError["logoUrl"] = "";
          }
          if (event.target.name === "mapImage") {
            //@ts-ignore
            formData["mapImage"].push(data.files[0]);
            //@ts-ignore
            formError["mapImage"] = "";
          }
          if (event.target.name === "imageUrl") {
            //@ts-ignore
            formData["imageUrl"].push(data.files[0]);
            //@ts-ignore
            formError["imageUrl"] = "";
          }
          if (event.target.name === "bannerImageUrl") {
            //@ts-ignore
            formData["bannerImageUrl"].push(data.files[0]);
            //@ts-ignore
            formError["bannerImageUrl"] = "";
          }
          setParkData(formData);
          setError(formError);
        } catch (error: any) {
          toast.error(<ToastMessage message="File cannot be uploaded." />, {
            hideProgressBar: true,
          });
        }
      }
    };
  };

  const handleTimeSelect = (value: any, fromTo: any, name: any) => {
    if (name === "timeSingle") {
      let timeObj = { ...time.timeSingle };
      //@ts-ignore
      timeObj[fromTo] = value;
      setError({ ...error, timeSingle: "" });
      setTime({ ...time, timeSingle: { ...timeObj } });
    } else {
      let timeObj = { ...time.timeMulti };
      let err = { ...error };
      //@ts-ignore
      timeObj[name][fromTo] = value;
      //@ts-ignore
      err["time"][name] = "";
      setTime({ ...time, timeMulti: { ...timeObj } });
      setError(err);
    }
  };

  const handleVisitTimeChange = (e: any) => {
    setTime({
      type: e.target.value,
      timeMulti: {
        mon: {
          start: "",
          end: "",
        },
        tue: {
          start: "",
          end: "",
        },
        wed: {
          start: "",
          end: "",
        },
        thu: {
          start: "",
          end: "",
        },
        fri: {
          start: "",
          end: "",
        },
        sat: {
          start: "",
          end: "",
        },
        sun: {
          start: "",
          end: "",
        },
      },
      timeSingle: { start: "", end: "" },
    });
    setError({ ...error, timeType: "" });
  };

  const handleChange = (event: any) => {
    if (
      event.target.name === "logoUrl" ||
      event.target.name === "imageUrl" ||
      event.target.name === "mapImage"
    ) {
      uploadEvent(event);
    } else if (
      event.target.name === "specialProductsDates" ||
      event.target.name === "holidayAllowedDates" ||
      event.target.name === "restrictedDates"
    ) {
      let res = event?.target?.value?.map((val: any) =>
        dayjs(val).format("YYYY/MM/DD")
      );
      let formData = { ...parkData };
      let formError = { ...error };
      //@ts-ignore
      formData[event.target.name] = res;
      //@ts-ignore
      formError[event.target.name] = "";
      setParkData(formData);
      setError(formError);
    } else {
      let formData = { ...parkData };
      let formError = { ...error };
      //@ts-ignore
      formData[event.target.name] = event.target.value;
      //@ts-ignore
      formError[event.target.name] = "";
      setParkData(formData);
      console.log(formData);

      setError(formError);
    }
  };

  const handleCancel = () => {
    setIsCancelModal(true);
  };

  const handleSubmit = () => {
    if (!validatePark(parkData, setError, time)) {
      setError({
        name: "",
        type: "",
        email: "",
        countryCode: "",
        phoneNumber: "",
        info: "",
        whatsappNumber: "",
        instaLink: "",
        fbLink: "",
        lat: "",
        long: "",
        address: "",
        iframe_url: "",
        tripAdvisor: "",
        logoUrl: "",
        imageUrl: "",
        masterName: "",
        masterEmail: "",
        bankName: "",
        accountNumber: "",
        legalEntity: "",
        sapCode: "",
        time: {},
        disclaimer: "",
        timeSingle: "",
        timeType: "",
        tc: "",
        segrateTimeSlot: "",
        mapImage: "",
      });

      if (id && dynamicPromoType) {
        const isError = validateDynamicPromotionData(
          dynamicPromoData,
          setDynamicPromoError,
          dynamicPromoType
        );

        if (isError) {
          toast.error("Please verify all the dynamic promotion fields");
          return;
        }
      }

      if (id) {
        updateData(
          getAddParkData(
            parkData,
            status,
            time,
            dynamicPromoData,
            dynamicPromoType,
            restrictProductDiscount,
            id
          )
        );
      } else {
        saveData(getAddParkData(parkData, status, time));
      }
    }
  };

  const saveData = async (data: any) => {
    try {
      let response = await addOutlet(data);
      if (response.status === 201) {
        setIsSuccessModal(true);
      }
    } catch (error: any) {
      if (navigator.onLine) {
        setIsFailureModal(true);
        setErrorMessage({
          heading: "Something went wrong.",
          subHeading: error.message,
        });
      }
    }
  };
  const updateData = async (data: any) => {
    try {
      let response = await updateOutlet(data, id);
      if (response.status === 200) {
        setIsSuccessModal(true);
      }
    } catch (error: any) {
      if (navigator.onLine) {
        setIsFailureModal(true);
        setErrorMessage({
          heading: "Something went wrong.",
          subHeading: error.message,
        });
      }
    }
  };

  const handleToggle = () => {
    setStatus(!status);
  };

  const removeImage = (e: any) => {
    let formData = { ...parkData };
    let formError = { ...error };
    //@ts-ignore
    formData.imageUrl = formData.imageUrl.filter((each) => each.viewUrl !== e);
    //@ts-ignore
    formData.mapImage = formData.mapImage.filter((each) => each.viewUrl !== e);
    //@ts-ignore
    formData.logoUrl = formData.logoUrl.filter((each) => each.viewUrl !== e);
    setParkData(formData);
    setError(formError);
    setUploadedImage(undefined);
  };

  useEffect(() => {
    if (id) {
      fetchOutletDetails(id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const addDynamicPromoData = (dPromoData: any, formattedDataforDD: any) => {
    console.log(dPromoData);

    const updatedProducts = formattedDataforDD.map((item: any, index: any) => {
      if (index === 0) {
        return { ...item, selected: false };
      }

      const selected = dPromoData?.products?.includes(item.value);
      return { ...item, selected };
    });

    const allSelectedExceptFirst = updatedProducts
      .slice(1)
      .every((item: any) => item.selected);

    if (allSelectedExceptFirst) {
      updatedProducts[0].selected = true;
      for (let i = 1; i < updatedProducts.length; i++) {
        updatedProducts[i].selected = false;
      }
    }

    console.log(updatedProducts);

    setDynamicPromoData({
      isEnabled: dPromoData?.isEnabled ? "true" : "false",
      restrictedDate: dPromoData?.restrictedDate || [],
      startDate: dPromoData?.startDate || "",
      endDate: dPromoData?.endDate || "",
      discountPercentage: dPromoData?.discountPercentage || "",
      promoCode: dPromoData?.promoCode || "",
      discountedPrice: dPromoData?.discountedPrice || "",
      isAllIncluded: allSelectedExceptFirst ? true : false,
      // @ts-ignore
      products: [...updatedProducts],
      details:
        dPromoData?.details?.length > 0
          ? [...dPromoData.details]
          : [
              {
                minQty: 0,
                freeQty: 0,
              },
            ],
    });
  };

  const fetchOutletDetails = async (id: string) => {
    setLoader(true);
    try {
      let { data } = await fetchOutletFromId(id);
      let { data: productsData } = await fetchAllActiveProducts(
        data?.data?.shortName,
        id
      );
      setRawOutletData(data?.data);

      const formattedProductsOnly = getFormattedProductListForDropdown(
        JSON.parse(JSON.stringify(productsData.data)),
        data?.data?.shortName,
        "productId"
      );

      const formattedDataforDD = [
        { label: "All Products", value: "all", selected: false },
        ...formattedProductsOnly,
      ];
      const existingKeys = DYNAMIC_PROMO_TYPES.filter(
        (promo) => promo.value && data?.data?.hasOwnProperty(promo.value)
      )
        .sort((a, b) => {
          const aActive = data.data[a.value]?.isEnabled === true ? 1 : 0;
          const bActive = data.data[b.value]?.isEnabled === true ? 1 : 0;
          return bActive - aActive;
        })
        .map((promo) => promo.value);

      if (data?.data?.restrictProductDiscount?.length > 0) {
        setRestrictProductDiscount(data?.data?.restrictProductDiscount);
      }

      setRestrictedProductOptions([
        // @ts-ignore
        { label: "Select Product", value: "" },
        // @ts-ignore
        ...formattedProductsOnly,
      ]);

      if (existingKeys[0]) {
        setDynamicPromoType(existingKeys[0]);
        addDynamicPromoData(data?.data[existingKeys[0]], formattedDataforDD);
      } else {
        // @ts-ignore
        setDynamicPromoData({
          ...dynamicPromoData,
          // @ts-ignore
          products: formattedDataforDD,
        });
      }
      if (data.code === 200) {
        setLoader(false);
        setParkData(getFomattedParkData(data.data));
        setTime(getParkTimingDetails(data?.data));
        setStatus(data.data.isActive);
      }
    } catch (error: any) {
      setLoader(false);
      if (navigator.onLine) {
        setIsFailureModal(true);
        setErrorMessage({
          heading: "Something went wrong.",
          subHeading: error.message,
        });
      }
    }
  };

  const handleUpdateDetails = (idx: number, type: "add" | "remove") => {
    setDynamicPromoData((prev) => {
      const currentDetails = prev.details || [];

      if (type === "add") {
        return {
          ...prev,
          details: [...currentDetails, { minQty: 0, freeQty: 0 }],
        };
      }

      if (type === "remove") {
        if (currentDetails.length <= 1) return prev;

        const updatedDetails = currentDetails.filter((_, i) => i !== idx);
        return {
          ...prev,
          details: updatedDetails,
        };
      }

      return prev;
    });
  };

  const handleChangeDetails = (value: any, name: string, index: number) => {
    setDynamicPromoData((prev) => {
      const updatedDetails = [...(prev.details || [])];

      updatedDetails[index] = {
        ...updatedDetails[index],
        [name]: value,
      };

      return {
        ...prev,
        details: updatedDetails,
      };
    });
    setDynamicPromoError((prev) => {
      // @ts-ignore
      const updatedErrors = [...(prev.details || [])];
      updatedErrors[index] = {
        ...updatedErrors[index],
        [name]: "",
      };
      return {
        ...prev,
        details: updatedErrors,
      };
    });
  };

  const handleDynamicPromoChange = (e: any) => {
    if (e.target.name === "dynamicPromoType") {
      setDynamicPromoType(e.target.value);
      setDynamicPromoError({});
      // @ts-ignore
      if (rawOutletData[e.target.value]) {
        // @ts-ignore
        console.log(rawOutletData[e.target.value]);

        addDynamicPromoData(
          // @ts-ignore
          rawOutletData[e.target.value],
          dynamicPromoData.products
        );
      } else {
        console.log("else");

        setDynamicPromoData({
          ...dynamicPromoData,
          isEnabled: "true",
          details: [
            {
              minQty: 0,
              freeQty: 0,
            },
          ],
          restrictedDate: [],
          startDate: "",
          endDate: "",
          discountPercentage: "",
          promoCode: "",
          discountedPrice: "",
        });
      }
    } else if (e.target.name === "restrictedDate") {
      setDynamicPromoError({ ...dynamicPromoError, restrictedDate: "" });

      let res = e?.target?.value?.map((val: any) =>
        dayjs(val).format("YYYY-MM-DD")
      );
      let formData = { ...dynamicPromoData };
      let formError = { ...error };
      //@ts-ignore
      formData[e.target.name] = res;
      //@ts-ignore
      formError[e.target.name] = "";
      setDynamicPromoData(formData);
      setError(formError);
    } else {
      setDynamicPromoError({ ...dynamicPromoError, [e.target.name]: "" });
      setDynamicPromoData({
        ...dynamicPromoData,
        [e.target.name]: e.target.value,
      });
    }
  };

  const handleProductSelect = (val: any) => {
    let formData = { ...dynamicPromoData };
    let selectedProduct: string[] = dynamicPromoData.products;

    if (val.value === "all") {
      let updatedProd = selectedProduct.map((prod: any) =>
        prod.value === "all"
          ? { ...prod, selected: true }
          : { ...prod, selected: false }
      );
      setDynamicPromoData({
        ...formData,
        // @ts-ignore
        products: updatedProd,
        isAllIncluded: true,
      });
    } else {
      let updatedProd = selectedProduct.map((prod: any) =>
        val.value === prod.value ? { ...prod, selected: !prod.selected } : prod
      );

      updatedProd[0].selected = false;

      setDynamicPromoData({
        ...formData,
        // @ts-ignore
        products: updatedProd,
        isAllIncluded: false,
      });
    }
    // @ts-ignore
    setDynamicPromoError({ ...dynamicPromoError, products: "" });
  };

  const handleRestrictedProductChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    idx: number
  ) => {
    const { name, value } = e.target;

    setRestrictProductDiscount((prev) => {
      const updated = [...prev];
      updated[idx] = {
        ...updated[idx],
        [name]:
          name === "excludeDate"
            ? // @ts-ignore
              value?.map((val: any) => dayjs(val).format("YYYY/MM/DD"))
            : value,
      };
      return updated;
    });
  };

  const handleUpdateRestrictedProduct = (
    idx: number,
    type: "add" | "remove"
  ) => {
    setRestrictProductDiscount((prev) => {
      const updated = [...prev];

      if (type === "add") {
        updated.push({ product: "", excludeDate: [] });
      } else if (type === "remove") {
        if (idx === 0 && updated.length === 1) {
          updated[0] = { product: "", excludeDate: [] };
        } else {
          updated.splice(idx, 1);
        }
      }

      return updated;
    });
  };

  return (
    <>
      <StyledDiv>
        <ParksHeader label={id ? "Edit Park" : "Add Park"} />
        <InfoWrapper>
          <InfoAndText text="(This toggle is to activate and deactivate the Park)" />
          <StyledStatus>
            Status:
            <Toggle
              uniqueName={"status"}
              isChecked={status}
              onChange={handleToggle}
            />
            <ActiveDeactive status={status}>
              {status ? "Active" : "Inactive"}
            </ActiveDeactive>
          </StyledStatus>
        </InfoWrapper>
      </StyledDiv>
      <AddParkForm
        id={id}
        onCancel={handleCancel}
        onSubmit={handleSubmit}
        onChange={handleChange}
        onRemove={removeImage}
        error={error}
        value={parkData}
        uploadedImage={uploadedImage}
        onTimeSelect={handleTimeSelect}
        time={time.timeMulti}
        timeType={time.type}
        timeSingle={time.timeSingle}
        onVisitTimeChange={handleVisitTimeChange}
        dynamicPromoData={dynamicPromoData}
        dynamicPromoType={dynamicPromoType}
        dynamicPromoError={dynamicPromoError}
        restrictProductDiscount={restrictProductDiscount}
        productsOptions={productsOptions}
        onUpdateDetails={handleUpdateDetails}
        onChangeDetails={handleChangeDetails}
        onDynamicPromoChange={handleDynamicPromoChange}
        onProductSelect={handleProductSelect}
        onRestrictedProductChange={handleRestrictedProductChange}
        onUpdateRestrictedProduct={handleUpdateRestrictedProduct}
      />
      {isFailureModal && (
        <ErrorSuccessModal
          variant="error"
          heading={errorMessage.heading}
          subHeading={errorMessage.subHeading}
          buttonLabel="Ok"
          setOpenOrClose={setIsFailureModal}
          onSubmit={() => setIsFailureModal(false)}
        />
      )}
      {isSuccessModal && (
        <ErrorSuccessModal
          variant="success"
          heading="Outlet details saved successfully."
          buttonLabel="Ok"
          setOpenOrClose={setIsSuccessModal}
          onSubmit={() => {
            setIsSuccessModal(false);
            navigate("/admin/manage-parks");
          }}
        />
      )}
      {isCancelModal && (
        <ConfirmModal
          heading="Are you sure you want to leave ?"
          subHeading="Hey there! It looks like you're in the middle of something and you haven't saved all of your content. Save before you go!"
          button2Label="Save"
          button1Label="Leave"
          button1Submit={() => {
            setIsCancelModal(false);
            navigate("/admin/manage-parks");
          }}
          button2Submit={() => {
            setIsCancelModal(false);
          }}
          setOpenOrClose={setIsCancelModal}
        />
      )}
    </>
  );
};

export const StyledDiv = styled.div`
  display: flex;
  justify-content: space-between;
  @media only screen and (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;
export const InfoWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  @media only screen and (max-width: 768px) {
    flex-direction: column-reverse;
    align-items: flex-start;
    margin: 1.5625rem 1.5625rem 0 1.5625rem;
  }
`;
export const StyledStatus = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  font-size: 0.8125rem;
`;
export const ActiveDeactive = styled.div<StatusProps>`
  color: ${(props) => (props.status ? Colors.appleGreen : Colors.appleRed)};
  width: 6rem;
`;

export default AddPark;
